import React, { useEffect, useState } from "react";
import api from "../../api";
import { InStoreSaleForm } from "../../components/InStoreSaleForm";

export default function SellTab() {
  const [products, setProducts] = useState([]);
  useEffect(() => { api.get("/business/products").then(({ data }) => setProducts((data.products || data || []).filter((p) => p.active !== false))).catch(() => {}); }, []);
  const sell = async (payload) => (await api.post("/business/sell-in-store", payload)).data;
  return (
    <div className="max-w-[560px]" data-testid="sell-tab">
      <div className="bg-white rounded-2xl p-6 shadow-[0_8px_24px_rgba(20,30,55,0.06)]">
        <h2 className="font-semibold text-[#16243b]">Sell a voucher at the till</h2>
        <p className="text-sm text-[#5a6b80] mt-1 mb-5">Sales made here appear in Sold vouchers and your reports. No platform fee is charged on in-store sales.</p>
        <InStoreSaleForm products={products} onSell={sell} />
      </div>
    </div>
  );
}
